import { Box, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";

export const EmptyPrizes = () => {
  return (
    <Box
      sx={{
        textAlign: "center",
        py: 10,
        bgcolor: "white",
        borderRadius: 4,
        border: "2px dashed hsl(30, 20%, 85%)",
      }}
    >
      <CardGiftcardIcon
        sx={{ fontSize: 64, color: "hsl(45, 90%, 50%)", mb: 2 }}
      />
      <Typography
        variant="h4"
        sx={{
          fontFamily: '"Mountains of Christmas", cursive',
          color: "hsl(150, 60%, 25%)",
          mb: 2,
        }}
      >
        Δεν υπάρχουν δώρα ακόμα!
      </Typography>
      <Typography sx={{ color: "hsl(150, 20%, 35%)", mb: 3 }}>
        Πρόσθεσε απίθανα δώρα για την λοταρία σου!
      </Typography>
      <Button
        component={Link}
        to={`/prizes/new`}
        variant="contained"
        startIcon={<AddIcon />}
        sx={{
          background:
            "linear-gradient(135deg, hsl(45, 90%, 50%) 0%, hsl(45, 85%, 40%) 100%)",
          color: "hsl(45, 90%, 15%)",
        }}
      >
        Προσθεσε το πρωτο δωρο
      </Button>
    </Box>
  );
};
